import { useMarketsEnabled } from "module/market/hook/useMarketsEnabled"

import { RouteName } from "constant/route"
import { useTickerSymbolFromRouterParams } from "hook/useRouterParams"
import { useMemo } from "react"
import { Redirect } from "react-router-dom"

import { PoolDetail } from "../PoolDetail"

function PagePoolDetail() {
    // TODO: merge this section of the code with MarketDetail
    const tickerSymbol = useTickerSymbolFromRouterParams()
    const { marketMap } = useMarketsEnabled()
    const isMarketEnabled = useMemo(
        () =>
            !!marketMap
                ? Object.values(marketMap)
                      .map(({ tickerSymbol }) => tickerSymbol)
                      .includes(tickerSymbol)
                : false,
        [marketMap, tickerSymbol],
    )

    if (marketMap && !isMarketEnabled) {
        return <Redirect to={RouteName.POOL_LIST} />
    }
    return <PoolDetail />
}

export default PagePoolDetail
